import DocusaurusFooter from '../DocusaurusFooter'
import {
  Color,
  Paragraph
} from '@eggplant/pattern-library'
import { customScripts } from '../../docs-routes'

const CustomScript = () =>
  <>
    <Paragraph>
      <Color variant='theme-description-text'>
        Custom scripts allow you to run a file on the execution environment before a test config run. They can execute any necessary Git commands to prepare the system, initialize data, set the system to a known state, or integrate with other version control systems.
      </Color>
    </Paragraph>
    <DocusaurusFooter path={customScripts} />
  </>

export default CustomScript
